import { Action } from 'redux';
import { Subject } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import { nextStep } from '../../application/reducers/next-step';
import {
  uploadFinancialDocuments,
  uploadFinancialDocumentsFail,
  uploadFinancialDocumentsSuccess,
  uploadStatusUpdate,
} from '../reducers/document-requirements.reducer';

export const uploadFinancialDocumentsEpic: RootEpic = (action$, state$, { api: { qualification } }) => {
  return action$.pipe(
    filter(uploadFinancialDocuments.match),
    mergeMap(({ payload: { document, files } }) => {
      const subject = new Subject<Action>();

      qualification
        .uploadFinancialDocuments(document, files, (event) => {
          subject.next(uploadStatusUpdate(event));
        })
        .then(() => {
          subject.next(uploadFinancialDocumentsSuccess());
          subject.next(
            nextStep({
              action: 'collect_financials',
              gotoNextPage: true,
            }),
          );
          subject.complete();
        })
        .catch((error: ErrorType) => {
          subject.next(uploadFinancialDocumentsFail(error));
          subject.complete();
        });

      return subject;
    }),
  );
};
